







































































































































































































































































































































import {Component, Prop, Vue, Watch, Mixins} from "vue-property-decorator";
import { AppealCustomFields } from "@/models/appeals";
import DropdownWithDatePickerWithoutRange from "@/components/hoc/DropdownWithDatePickerWithoutRange.vue";
import TimePicker from "@/components/hoc/TimePicker.vue";
import DropdownWithRadioButtons from "@/components/hoc/DropdownWithRadioButtons.vue";
import XDropdownWithRadioButtons from "@/components/hoc/DropdownWithRadioButtons.vue";
import {FieldTypes} from "@/assets/scripts/custom-fields/field-types"
import XDropdownWithDatePickerField
  from "@/components/hoc/DropdownWithDatePickerField.vue";
import FileInputMixin from "@/components/mixins/FileInputMixin.vue";

@Component({
  computed: {
    FieldTypes() {
      return FieldTypes
    },
    fieldName() {
      return this.item['название'] + (this.required ? "*" : "")
    }
  },
  components: {
    XDropdownWithDatePickerField,
    XDropdownWithRadioButtons,
    DropdownWithDatePickerWithoutRange,
    TimePicker,
    DropdownWithRadioButtons,
  }
})
class CustomForm extends Mixins(FileInputMixin) {
  [x: string]: any

  @Prop({ default: "" }) readonly errorMessages!: string;
  @Prop({ required: true }) readonly item!: AppealCustomFields;
  @Prop({ default: false }) readonly required!: boolean;
  @Prop({ default: false }) readonly disabled!: boolean;

  showCustomInput = false;
  newFiles: File[] = [];
  fileList: File[] = [];
  fileError: string = "";

  mounted() {
    // Инициализируем значение как массив для файлов
    if (this.item['тип'] === FieldTypes.FILE) {
      this.item['значение'] = this.item['значение'] || [];

      // Если уже есть файлы, загружаем их
      if (Array.isArray(this.item['значение'])) {
        this.fileList = [...this.item['значение']];
      }
    } else {
      this.item['значение'] = "";
    }

    if (this.item['мультивыбор'] === 2 || this.item['мультивыбор'] === 3) {
      this.item['свойвариант'] = "";
    }
  }

  @Watch('fileList')
  onFileListChanged() {
    // Обновляем значение в item
    this.item['значение'] = [...this.fileList];
    this.validateFiles();
    // Эмитим событие для родительского компонента
    this.$emit('file-changed');
  }

  /**
   * Добавление новых файлов
   */
  onFilesAdded(files: File[]) {
    if (files && files.length > 0) {
      // Добавляем новые файлы к существующим
      const existingFileNames = this.fileList.map(f => f.name);
      const uniqueNewFiles = files.filter(file =>
        !existingFileNames.includes(file.name)
      );

      if (uniqueNewFiles.length > 0) {
        this.fileList = [...this.fileList, ...uniqueNewFiles];
      }

      // Очищаем поле ввода
      this.newFiles = [];
    }
  }

  /**
   * Хинт с информацией о файлах
   */
  getFileHint() {
    return this.getAppealsAcceptedExtensionsHint();
  }

  /**
   * Текст для счетчика
   */
  getCounterText() {
    if (this.fileList.length > 0) {
      return `${this.fileList.length} файлов`;
    }
    return '';
  }

  /**
   * Удаление файла
   */
  removeFile(index: number) {
    this.fileList.splice(index, 1);
    // Создаем новый массив для реактивности
    this.fileList = [...this.fileList];
  }

  /**
   * Удаление файла по имени
   */
  removeFileByFileName(fileName: string) {
    const index = this.fileList.findIndex(file => file.name === fileName);
    if (index !== -1) {
      this.removeFile(index);
    }
  }

  /**
   * Валидация файлов
   */
  validateFiles() {
    this.fileError = "";

    if (this.fileList.length === 0 && this.required) {
      this.fileError = "Необходимо загрузить хотя бы один файл";
      return false;
    }

    const errorMessages = this.checkFiles(this.fileList);

    if (errorMessages.length > 0) {
      this.fileError = errorMessages.join(', ');
      return false;
    }

    return true;
  }

  /**
   * Программный клик по полю ввода файлов
   */
  triggerFileInput() {
    // Можно добавить логику для программного клика
    // или оставить как есть, так как v-file-input сам обрабатывает клик
  }

  setValue(data) {
    this.item['значение'] = data;
  }

  setValueCheckbox(data) {
    this.item['значение'] = this.item['значение'] ?? "";

    if (this.item['значение'].split(';').find(elem => elem === data)) {
      this.item['значение'] = this.item['значение'].split(';').filter(el => el !== data).join(';');
    } else {
      this.item['значение'] += data + ';';
    }
  }

  setDateTime(data) {
    if(data['displayTime'] !== undefined) {
      this.item['значение-2'] = data['displayTime'] + ':00';
    } else {
      this.item['значение-1'] = data.split('T')[0].split('-').reverse().join('.');
    }
    this.item['значение'] = this.item['значение-1'] + ' ' + this.item['значение-2'];
  }

  onFileChanged(files: Array<File>) {
    this.item['значение'] = files;
  }

  setValueCustom() {
    this.showCustomInput = !this.showCustomInput;
  }

  customRule() {
    if (this.required) {
      return [
        v => !!v || "Заполните данное поле",
      ];
    }
    return [];
  }

  customRuleFile() {
    // Для файловых полей используем отдельную валидацию
    if (this.required) {
      return [
        v => {
          // Проверяем, есть ли файлы в fileList
          return this.fileList.length > 0 || "Загрузите хотя бы один файл";
        }
      ];
    }
    return [];
  }

  customRuleRange() {
    if (this.required) {
      return [
        v => (v || '__.____ - __.____') != '__.____ - __.____' || 'Заполните данное поле'];
    }
    return [];
  }
}

export default CustomForm;
